import CustomerService from '_services/rest/modules/customer';
import { CONTACT, ADDRESS } from './components/CustomerModel';

export default {
  state: {
    customer: null,
    customerList: null,
  },
  mutations: {
    setCustomerList(state, response) {
      state.customerList = response;
    },
    setCustomer(state, response) {
      state.customer = response;
      state.type = response.type || 'individual';
    },
    setCustomerAddress(state, addresses) {
      if (addresses.length > 0) {
        addresses.forEach(address => {
          if (address.address) {
            const [street, number] = address.address.split(', ');
            address.street = street;
            address.number = number;
          } else {
            address.street = '';
            address.number = '';
          }
        });
        state.customer.addresses = addresses;
        return;
      }
      state.customer.addresses = [{ ...ADDRESS }];
    },
    setCustomerProject(state, projects) {
      if (projects.length > 0) {
        projects.forEach(project => {
          const [street, number] = project.address.split(', ');
          project.address.street = street;
          project.address.number = number;
        });
        state.customer.projects = projects;
      }
    },
    setCustomerContact(state, contacts) {
      if (contacts.length > 0) {
        state.customer.contacts = contacts;
        return;
      }
      state.customer.contacts = [{ ...CONTACT }];
    },
  },
  actions: {
    getCustomerList({ commit }, params) {
      return CustomerService.getList(params)
        .then(response => {
          commit('setCustomerList', response);
        });
    },
    getCustomer(store, params) {
      return CustomerService.getCustomerById(params)
        .then(response => {
          const customer = response;
          store.dispatch('commitCustomer', customer);
        });
    },
    getCustomerAddress({ commit }, addresses) {
      commit('setCustomerAddress', addresses);
    },
    commitCustomer({ commit }, customer) {
      commit('setCustomer', customer);
      commit('setCustomerAddress', customer.addresses);
      commit('setCustomerContact', customer.contacts);
      commit('setCustomerProject', customer.projects);
    },
  },
};
